import script from "./CobroFacturaVentaView.vue?vue&type=script&setup=true&lang=js"
export * from "./CobroFacturaVentaView.vue?vue&type=script&setup=true&lang=js"

import "./CobroFacturaVentaView.vue?vue&type=style&index=0&id=efb527f6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-efb527f6"]])

export default __exports__